export default __webpack_public_path__ + "static/media/mongodb.b54e9db2.svg";